export const MESSAGING_API_LEGACY_VERSION = '2021-06-10';
export const MESSAGING_API_LATEST_VERSION = '2026-05-26';

export const MESSAGING_CLIENT_ELEMENT_ID = 'ember-messaging-client';

export const MODEL_NAMES = {
  CONTACT: 'messaging-contact',
  CONVERSATION: 'messaging-conversation',
  MESSAGE: 'messaging-message',
  PROFILE: 'messaging-profile',
  SYSTEM_USER: 'messaging-system-user',
  USER: 'messaging-user',
};
